<ng-container *ngIf="!showTable; else content">
  <div class="loading text-center">
      <br />
      <img style="padding-top:50px;" src="../../../assets/img/gif/loading.gif" alt="Alternate Text" />
      <br />
      <p>Loading, please wait...</p>
  </div>
</ng-container>

<ng-template #content>
  <!-- <div class="card shadow topSpacing"> -->
    <div class="active-client-container">
      <div class="container-fluid" style="padding: 15px;">
    
        <div>
            <div class="row container-fluid">
                <div class="col-md-8 noPadding">
                    <div>
                        <div class="row">
                            <div class="col-sm-12 col-md-12">
                                <div class="tags-wrap">
                                    <div *ngFor="let tag of tags; let i = index;" class="tag">
                                        {{tag}}
                                        <span title="Delete" (click)="removeTag(i, $event)">&times;</span>
                                    </div>
                                </div>
                            </div>
                        </div>
      
                        <!--<label style="text-transform: capitalize;" for="iS">Search: </label>-->
                        <div style="margin-top:10px;">
                            <input *ngIf="!showFilterFields" id="iS" type="text" (click)="toggleFilter()" placeholder="Click here to add a filter" />
                            <i *ngIf="!showFilterFields" (click)="toggleFilter()" class="fas fa-search"></i>
                        </div>
      
                        <div class="cfilter" style="margin-bottom:10px;">
                            <div *ngIf="showFilterFields">
                                <select #field id="field">
                                    <option value=""></option>
                                    <option *ngFor="let field of fields" value="{{field}}">{{field}}</option>
                                </select>
      
                                <select #filter id="filter">
                                    <option value=""></option>
                                    <option *ngFor="let filter of filters" value="{{filter.value}}">{{filter.text}}</option>
                                </select>
      
                                <input #condition id="condition1" placeholder="Condition" type="text" value="" (keyup.enter)="applyFilter(field.value, filter.value, condition.value)" />
      
                                <a (click)="applyFilter(field.value, filter.value, condition.value)">Add</a>
      
                            </div>
                        </div>
      
                        <br />
                    </div>
                </div>
      
                <div class="col-md-6 text-right noPadding" style="position: absolute; top:7px; right: 1px; z-index: 3;">
                    <div class="btns-container">
                      <a (click)="openActivateModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" style="margin-right: 5px;text-align: justify;" [ngClass]="{'btn-other': canDelete, 'btn-gray': !canDelete}">
                        <i class="fas fa fa-play-circle text-white-50"> <span class="button-text"> Restore</span></i>
                      </a>
                      <a (click)="openConfirmationModal()" class="d-none d-sm-inline-block btn btn-sm shadow-sm margin-right-5" [ngClass]="{'btn-red': canDelete, 'btn-gray': !canDelete}">
                        <i class="fas fa-trash text-white-50"> <span class="button-text"> Delete</span></i>
                      </a>
                    </div>
                </div>
            </div>
      
      
        </div>
      
        <div *ngIf="showTable" id="clientsGrid" style="width: 100%; max-height: 400px; height:400px;">
            <ag-grid-angular #agGrid
                             style="width: 100%; height: 100%;"
                             class="ag-theme-balham"
                             [enableFilter]="true"
                             [floatingFilter]="true"
                             [gridOptions]="gridOptions"
                             [rowData]="clients"
                             [columnDefs]="clientsHeaders"
                             [enableSorting]="true"
                             [enableColResize]="true"
                             (gridReady)="onGridReady($event)"
                             [pagination]="true"
                             [paginationPageSize]="15"
                             [overlayNoRowsTemplate]="overlayNoRowsTemplate"
                             [rowSelection]="rowSelection"
                             [suppressRowClickSelection]="true"
                             (selectionChanged)="onSelectionChangedChoiceSet($event)"
                             (filterChanged)="filterChanged($event)"
                             (filterModified)="filterModified($event)">
            </ag-grid-angular>
        </div>
      </div>

    </div>
  <!-- </div> -->
</ng-template>


<div id="activateClientsModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h2 class="modal-title text-center">Restore Client(s).</h2>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body text-center">
              <p>Are you sure you want to restore as active these <b>Client(s)</b>?</p>
          </div>

          <div class="modal-footer">
              <div>
                  <div class="col-md-12">
                      <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                      <button (click)="activate()" type="button" class="btn btn-primary">Yes</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<!--/*modal*/-->
<div id="archiveReturnedModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h2 class="modal-title text-center">Clients</h2>
              <button type="button" class="close" (click)="closeModalReturned()" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body">
              <p>{{returnModalMessage}}</p>
              <div style="overflow:auto;max-height: 210px;">
                  <ul>
                      <li *ngFor="let client of returnedClients">{{client}}</li>
                  </ul>
              </div>
          </div>

          <div class="modal-footer">
              <div>
                  <div class="col-md-12">
                      <button (click)="closeModalReturned()" type="button" class="btn btn-primary">Close</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>

<!--/*CONFIRMATION DELETE MODAL*/-->
<div id="archivedClientConfirmationDeleteModal" class="modal fade" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
      <div class="modal-content">
          <div class="modal-header">
              <h2 class="modal-title text-center">Delete Client(s)</h2>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
              </button>
          </div>

          <div class="modal-body text-center">
              <p>Are you sure you want to delete these <b>Client(s)</b>?</p>
          </div>

          <div class="modal-footer">
              <div>
                  <div class="col-md-12">
                      <button data-dismiss="modal" type="button" class="btn btn-secondary">No</button>
                      <button (click)="deleteArchived()" type="button" class="btn btn-primary">Yes</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>